import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import {
  CircleStackIcon,
  ChartBarIcon,
  CloudIcon,
  CpuChipIcon,
} from '@heroicons/react/24/outline';

const DataProcessing = () => {
  const serviceData = {
    icon: CircleStackIcon,
    title: 'Data Processing',
    description: 'Advanced data processing and web hosting solutions to manage your business information efficiently, securely, and at scale with modern cloud technologies.',
    gradient: 'from-green-900 to-green-800',
    technologies: [
      'Python & R',
      'Apache Spark',
      'PostgreSQL',
      'MongoDB',
      'AWS & GCP',
      'Tableau & Power BI',
    ],
    features: [
      {
        icon: ChartBarIcon,
        title: 'Data Analytics',
        description: 'Transform raw data into actionable business insights and reports.',
      },
      {
        icon: CloudIcon,
        title: 'Cloud Hosting',
        description: 'Reliable and scalable cloud hosting solutions for your applications.',
      },
      {
        icon: CpuChipIcon,
        title: 'Real-time Processing',
        description: 'Process and analyze data in real-time for immediate decision making.',
      },
    ],
    services: [
      'Data Migration & Integration',
      'Database Design & Optimization',
      'Business Intelligence Solutions',
      'Cloud Hosting & Management',
      'Data Warehousing',
      'ETL Pipeline Development',
      'Real-time Data Processing',
      'Data Visualization & Reporting',
    ],
    whyChoose: [
      'Scalable Cloud Infrastructure',
      'Advanced Analytics Capabilities',
      'Secure Data Processing',
      'Custom Reporting Solutions',
    ],
  };

  return <ServiceTemplate {...serviceData} />;
};

export default DataProcessing;
